import { render, staticRenderFns } from "./AliCloud.vue?vue&type=template&id=7ff71dbe&scoped=true&"
import script from "./AliCloud.vue?vue&type=script&lang=js&"
export * from "./AliCloud.vue?vue&type=script&lang=js&"
import style0 from "./AliCloud.vue?vue&type=style&index=0&id=7ff71dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff71dbe",
  null
  
)

export default component.exports